<template>
  <div class="editor-overlay editor-help-overlay">
    <i :class="['far', 'fa-fw', icon]" /> <span class="help-text">{{text}}</span>
    <a href="#" v-if="showClose" class="editor-overlay-close-button" @click.prevent="onClose">
      <i class="far fa-times"> </i>
    </a>
  </div>
</template>

<style scoped>
.editor-help-overlay {
  width: 40vw;
  height: 50px;
  min-width: 40vw;
  min-height: 50px;
  
  padding: 0px 5px;
  line-height: 50px;
  vertical-align: middle;

  font-size: 1.2rem;
  background-color: #ffffff;
  color: #60727a;
  border: 1px solid rgb(207, 207, 207);
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(207, 207, 207, 0.75);
}
.editor-help-overlay > i {
  margin-left: 4px;
  margin-right: 10px;
  font-size: 1.6rem;
  color: #b7bfc7;
}

.editor-overlay-close-button {
  color: #6c757d;
  float: right;
  margin-right: 1rem;
  pointer-events: visible;
}
</style>

<script>
import EditorPopoverMixin from '../mixins/editorPopover'

export default {
  name: 'EditorHelperOverlay',
  mixins: [EditorPopoverMixin],
  props: {
    text: String,
    icon: String,
    showClose: Boolean
  },
  mounted() {
    
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
}
</script>